export const getAbuseWords = (info: string) => {
    if (!info) {
        return [];
    }

    return info.split(', text: ')[0]?.split('Abuse reason: ')[1]?.split(', ') ?? [];
}